"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypographyConfig = void 0;
exports.TypographyConfig = {
    fontFamily: '"Source Sans Pro", sans-serif',
    htmlFontSize: 16,
    h1: {
        fontSize: '1.75rem',
        fontWeight: 600,
        fontStyle: 'normal',
    },
    h2: {
        fontSize: '1.5rem',
        fontWeight: 600,
        fontStyle: 'normal',
    },
    h3: {
        fontSize: '1.25rem',
        fontWeight: 600,
        fontStyle: 'normal',
    },
    h4: {
        fontSize: '1rem',
        fontWeight: 600,
        fontStyle: 'normal',
    },
    h5: {
        fontSize: '1rem',
        fontWeight: 'normal',
        fontStyle: 'normal',
    },
    h6: {
        fontSize: '0.875rem',
        fontWeight: 600,
        fontStyle: 'normal',
    },
    body1: {
        fontSize: '0.875rem',
        fontWeight: 600,
        fontStyle: 'normal',
    },
    body2: {
        fontSize: '0.875rem',
        fontWeight: 'normal',
        fontStyle: 'normal',
    },
    caption: {
        fontSize: '0.75rem',
        fontWeight: 600,
        fontStyle: 'normal',
    },
    subtitle1: {
        fontSize: '0.625rem',
        fontWeight: 600,
        fontStyle: 'normal',
    },
    subtitle2: {
        fontSize: '0.625rem',
        fontWeight: 'normal',
        fontStyle: 'normal',
    },
    button: {
        fontSize: '0.625rem',
        fontWeight: 600,
        fontStyle: 'normal',
        textTransform: 'uppercase',
    },
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 600,
    fontWeightBold: 700,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwb2dyYXBoeS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb25zdGFudHMvdGhlbWUvdHlwb2dyYXBoeS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFTYSxRQUFBLGdCQUFnQixHQUE4QjtJQUN6RCxVQUFVLEVBQUUsK0JBQStCO0lBQzNDLFlBQVksRUFBRSxFQUFFO0lBQ2hCLEVBQUUsRUFBRTtRQUNGLFFBQVEsRUFBRSxTQUFTO1FBQ25CLFVBQVUsRUFBRSxHQUFHO1FBQ2YsU0FBUyxFQUFFLFFBQVE7S0FDcEI7SUFDRCxFQUFFLEVBQUU7UUFDRixRQUFRLEVBQUUsUUFBUTtRQUNsQixVQUFVLEVBQUUsR0FBRztRQUNmLFNBQVMsRUFBRSxRQUFRO0tBQ3BCO0lBQ0QsRUFBRSxFQUFFO1FBQ0YsUUFBUSxFQUFFLFNBQVM7UUFDbkIsVUFBVSxFQUFFLEdBQUc7UUFDZixTQUFTLEVBQUUsUUFBUTtLQUNwQjtJQUNELEVBQUUsRUFBRTtRQUNGLFFBQVEsRUFBRSxNQUFNO1FBQ2hCLFVBQVUsRUFBRSxHQUFHO1FBQ2YsU0FBUyxFQUFFLFFBQVE7S0FDcEI7SUFDRCxFQUFFLEVBQUU7UUFDRixRQUFRLEVBQUUsTUFBTTtRQUNoQixVQUFVLEVBQUUsUUFBUTtRQUNwQixTQUFTLEVBQUUsUUFBUTtLQUNwQjtJQUNELEVBQUUsRUFBRTtRQUNGLFFBQVEsRUFBRSxVQUFVO1FBQ3BCLFVBQVUsRUFBRSxHQUFHO1FBQ2YsU0FBUyxFQUFFLFFBQVE7S0FDcEI7SUFDRCxLQUFLLEVBQUU7UUFDTCxRQUFRLEVBQUUsVUFBVTtRQUNwQixVQUFVLEVBQUUsR0FBRztRQUNmLFNBQVMsRUFBRSxRQUFRO0tBQ3BCO0lBQ0QsS0FBSyxFQUFFO1FBQ0wsUUFBUSxFQUFFLFVBQVU7UUFDcEIsVUFBVSxFQUFFLFFBQVE7UUFDcEIsU0FBUyxFQUFFLFFBQVE7S0FDcEI7SUFDRCxPQUFPLEVBQUU7UUFDUCxRQUFRLEVBQUUsU0FBUztRQUNuQixVQUFVLEVBQUUsR0FBRztRQUNmLFNBQVMsRUFBRSxRQUFRO0tBQ3BCO0lBQ0QsU0FBUyxFQUFFO1FBQ1QsUUFBUSxFQUFFLFVBQVU7UUFDcEIsVUFBVSxFQUFFLEdBQUc7UUFDZixTQUFTLEVBQUUsUUFBUTtLQUNwQjtJQUNELFNBQVMsRUFBRTtRQUNULFFBQVEsRUFBRSxVQUFVO1FBQ3BCLFVBQVUsRUFBRSxRQUFRO1FBQ3BCLFNBQVMsRUFBRSxRQUFRO0tBQ3BCO0lBQ0QsTUFBTSxFQUFFO1FBQ04sUUFBUSxFQUFFLFVBQVU7UUFDcEIsVUFBVSxFQUFFLEdBQUc7UUFDZixTQUFTLEVBQUUsUUFBUTtRQUNuQixhQUFhLEVBQUUsV0FBVztLQUMzQjtJQUNELGVBQWUsRUFBRSxHQUFHO0lBQ3BCLGlCQUFpQixFQUFFLEdBQUc7SUFDdEIsZ0JBQWdCLEVBQUUsR0FBRztJQUNyQixjQUFjLEVBQUUsR0FBRztDQUNwQixDQUFDIn0=